export default __webpack_public_path__ + "293fd13dbca5a3e450ef1ebfb232a299.woff2";